import i18n from '@/libs/i18n'

export enum Errors {
    InternalServerError = 1,
    InvalidData         = 2,
    NotFound            = 3,
    Unauthorized        = 4,
    FailedToInsert      = 5,
    Forbidden           = 6,
    Conflict            = 7,
    RateLimited         = 8,
    Blocked             = 9,
    Precondition        = 10,
    FursError           = 11,
    TermsRequired       = 12,
    QuotaExceeded       = 13,
    IncorrectStatus     = 14,
    RejectedFile        = 15,
}

interface ErrorBody {
    error?: { code?: number, message?: string, fields?: Record<string, string> } | string
}

/**
 * The API returns user-facing Slovenian messages (API.md), so the message is shown as is;
 * the code only picks a generic fallback when there is no message.
 */
export const parseError = (errorObject: unknown, fallback = ''): string => {
    const t = i18n.global.t
    const body = errorObject as ErrorBody | null
    const err = body?.error
    if (typeof err === 'string' && err) return err
    if (err && typeof err === 'object') {
        if (err.message) return err.message
        switch (err.code) {
            case Errors.InvalidData:  return t('errors.invalid_data')
            case Errors.NotFound:     return t('errors.not_found')
            case Errors.Unauthorized: return t('errors.unauthorized')
            case Errors.Forbidden:    return t('errors.forbidden')
            case Errors.RateLimited:  return t('errors.rate_limited')
            default: break
        }
    }
    return fallback || t('errors.generic_error')
}

/** Field errors from a 400 response, keyed by input name. */
export const parseFieldErrors = (errorObject: unknown): Record<string, string> => {
    const body = errorObject as ErrorBody | null
    const err = body?.error
    if (err && typeof err === 'object' && err.fields) return { ...err.fields }
    return {}
}

export const errorCode = (errorObject: unknown): number | undefined => {
    const body = errorObject as ErrorBody | null
    const err = body?.error
    return err && typeof err === 'object' ? err.code : undefined
}
